import type { VehicleViewFormData } from "@dealer-center/inventory-pages-gvm-interface";
import { useSearchParams } from "react-router-dom";
import { PagesGvmUi } from "../index";

function vehicleFromQueryParams(
  queryParams: URLSearchParams
): VehicleViewFormData {
  if (queryParams.size === 0) {
    return { editingVehicle: false };
  }

  return {
    editingVehicle: queryParams.has("id"),
    locale: queryParams.get("locale")?.toUpperCase() ?? "US_EN",
    vehicleId: queryParams.get("id") ?? ""
  };
}

export const VehicleWrapperPage = () => {
  const [searchParams] = useSearchParams();
  const editVehicle = vehicleFromQueryParams(searchParams);

  return <PagesGvmUi editVehicle={editVehicle} />;
};
